<template lang="pug">
.item-wrapper
  .flex
    button.expand-icon(v-if="hasChildren" :class="expandStateClass" @click="toggleExpandState")
      BriqIcon(name="icon-input-arrow-down-icon")
    .item-name-wrapper.bu-selection-label
      slot(name="label" v-bind:item="item")
  transition(name="slide")
    div(v-if="hasChildren" v-show="isItemExpanded")
      BriqTreeBranch(
        v-for="subitem in item.children"
        :key="subitem.name"
        :item="subitem"
        :query="query"
        :itemsWithExpansionState="itemsWithExpansionState"
        )
        template(v-for="slot in Object.keys($scopedSlots)" :slot="slot" slot-scope="scope")
          slot(:name="slot" v-bind="scope")
</template>

<script>
import { find, propEq } from 'ramda'

export default {
  name: 'BriqTreeBranch',
  props: { item: Object, query: String, itemsWithExpansionState: Array },
  computed: {
    queryMatchesItem() {
      if (!this.query) return true
      return this.item.name.toLowerCase().includes(this.query.toLowerCase())
    },
    hasChildren() {
      return this.item.children.length > 0
    },
    isItemExpanded() {
      return this.itemWithExpansionState?.expanded
    },
    expandStateClass() {
      return this.isItemExpanded ? 'expand-state' : ''
    },
    itemWithExpansionState() {
      return this.hasChildren
        ? find(propEq('key', this.item.key))(this.itemsWithExpansionState)
        : null
    },
  },
  methods: {
    toggleExpandState() {
      this.itemWithExpansionState.expanded = !this.itemWithExpansionState.expanded
    },
  },
}
</script>

<style scoped lang="stylus">
.item-wrapper
  margin-left 30px

.item-name-wrapper
  display flex
  align-items center

.expand-icon
    transform rotate(-90deg)
    border-radius 30px
    height 30px
    width 30px
    transition: transform 0.2s;
    margin-left: -30px;
    margin-top: 10px;

    &:focus
      outline 0px
      background-color #E7E7E7

  .expand-state
    transform rotate(0deg)

.bu-selection-label
  margin-top 4px
  border-radius 24px
  padding-left 6px
  min-height 40px
  display flex
  align-items center
  transition background-color 0.2s ease
  cursor pointer
  overflow hidden
  text-align left
  width 100%

  &:hover
    background-color whitesmoke
</style>
